module.exports = __webpack_public_path__ + "img/loves.35ca64d2.png";